import React = require("react");
import { H2 } from "../../../designSystem/typography/Heading";
import { ActivityType, AgendaMeetingActivityListing, CustomFormActivityListing } from '../../../amorg-common';
import { SurveyActivityListing } from '../../../amorg-common';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { PageHeader } from "../../../designSystem/PageHeader";
import { PageSection } from "../../../designSystem/PageSection";
import { SafetyInspectionActivityListing } from "../../../amorg-common/DTOs/SafetyInspectionActivityListing";
import { SurveyActivityListingView } from "../WorkplaceAssessmentActivity/WorkplaceAssessmentListingView";
import { SafetyInspectionView } from "../SafetyInspection/SafetyInspectionListingView";
import { AgendaMeetingView } from "./AgendaMeetingListingView";
import { Button } from '../../../designSystem/button/Button';
import { MessageCard } from "../../../designSystem/Message";
import { CustomFormActivityView } from "../../../pages/ergonomy/ErgonomicsPage";
import { iconName } from "../../../designSystem/icons/Icons";

type AcceptedActivityType = AgendaMeetingActivityListing | SurveyActivityListing | SafetyInspectionActivityListing | CustomFormActivityListing;

export type GenericActivityListingViewProps = {
    headerText:string,
    pastHeaderText:string,
    newActivityButtonText:string,
    activities:AcceptedActivityType[],
    onClick:(activityId:string)=>void,
    onClickNew:()=>void,
    toolBarButtons?:React.ReactNode,
    headerIcon?:iconName
}
export function GenericActivityListingView(props:GenericActivityListingViewProps): JSX.Element
{
    const now = new Date();
    const current = props.activities.filter(a => a.end.getTime() >= now.getTime());
    const past = props.activities.filter(a => a.end.getTime() < now.getTime());

	return (
        <>
            <PageHeader 
                headerIcon={props.headerIcon}
                headerText={props.headerText} 
                headerStyle="secondary-gray"
                buttons={props.toolBarButtons}
            />
            
            <Flex justifyContent="flex-end" gap={4}>
                <Button variant="filled" icon="actions_plus" text={props.newActivityButtonText} onClick={props.onClickNew} />
            </Flex>

            {current.length > 0
                ?   <Flex flexDirection="column" gap={24}>
                        <ActivityList activities={current} />
                    </Flex>
                :   <MessageCard variant="info">
                        Ingen aktiviteter er planlagt
                    </MessageCard>
            }

            {past.length > 0 &&
                <PageSection
                    header={<H2 color="gray">{props.pastHeaderText}</H2>}
                    defaultCollapsed={current.length > 0}>
                        
                    <Flex flexDirection="column" gap={24}>
                        <ActivityList activities={past} />
                    </Flex>
                </PageSection>
            }
        </>
	);
}

type ActivityListProps = {
    activities:AcceptedActivityType[]
}

export function ActivityList(props:ActivityListProps):JSX.Element
{
    function getActivityTypeList(activityType:ActivityType)
    {    
        if( activityType === "WorkplaceAssessment"){
            return (
                props.activities.map(a => {
                    return (
                        <SurveyActivityListingView activity={a as SurveyActivityListing} key={a.id} />
                    );
                })
            );
        }
        else if( activityType === "SafetyInspection"){
            return (
                props.activities.map(a => {
                    return (
                        <SafetyInspectionView listing={a as SafetyInspectionActivityListing} key={a.id} />
                    );
                })
            );
        }
        else if( activityType === "AnnualWorkgroupStatus" || activityType === 'WorkgroupMeeting'){
            return (
                props.activities.map(a => {
                    return (
                        <AgendaMeetingView activity={a as AgendaMeetingActivityListing} key={a.id} />
                    );
                })
            );
        }
        else if( activityType === "CustomForm"){
            return (
                props.activities.map(a => {
                    return (
                        <CustomFormActivityView listing={a as CustomFormActivityListing} key={a.id} />
                    );
                })
            );
        }
        else {
            throw new Error(`Unhandled activity type: ${activityType}`);
        }
    }

    return (
        <>
            {props.activities.length > 0 &&
                getActivityTypeList(props.activities[0].activityType)
            }
        </>
    );
}